import React from 'react';

import CopyTextInput from '@dashboard/components/form/fields/CopyTextInput';
import { CheckCircleOutline, HighlightOffOutlined, RemoveCircleOutline } from '@mui/icons-material';
import { TableCell, TableRow, Tooltip } from '@mui/material';
type Props = {
  isPresent?: boolean;
  name: string;
  value: string;
  recordType: string;
};

export default function DomainNameRow({ recordType, isPresent, name, value }: Props) {
  const renderIcon = (isPresent?: boolean) => {
    if (isPresent === undefined) {
      return (
        <Tooltip title="Undefined">
          <RemoveCircleOutline fontSize="small" sx={{ color: 'grey.300' }} />
        </Tooltip>
      );
    }
    if (isPresent) {
      return (
        <Tooltip title="Verified">
          <CheckCircleOutline fontSize="small" sx={{ color: 'brand.green' }} />
        </Tooltip>
      );
    }
    return (
      <Tooltip title="Inactive">
        <HighlightOffOutlined fontSize="small" sx={{ color: 'grey.600' }} />
      </Tooltip>
    );
  };
  return (
    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
      <TableCell align="center" sx={{ paddingTop: 1.5 }}>
        {renderIcon(isPresent)}
      </TableCell>
      <TableCell>{recordType}</TableCell>
      <TableCell>
        <CopyTextInput value={name} />
      </TableCell>
      <TableCell>
        <CopyTextInput value={value} />
      </TableCell>
    </TableRow>
  );
}
